import React, { useEffect, useRef, useState } from "react";
import { Columns3, Check } from "lucide-react";
import { STOCK_COLUMNS } from "./StockTable";

export default function ColumnSelector({ visibleColumns, setVisibleColumns }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  const toggle = (key) => {
    setVisibleColumns((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
    );
  };
  const allKeys = STOCK_COLUMNS.map((c) => c.key);
  const setAll = (on) => setVisibleColumns(on ? allKeys : []);

  return (
    <div className="relative" ref={ref}>
      <button data-testid="columns-btn" onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-1.5 bg-white border border-[#D2E0E6] text-[#47616B] px-3 py-2 rounded-md text-sm hover:bg-[#E0EBEF] hover:text-[#0B2830] transition-colors">
        <Columns3 className="w-4 h-4" /> Columns
        <span className="mono text-xs text-[#7C949C]">({visibleColumns.length})</span>
      </button>

      {open && (
        <div data-testid="columns-menu"
          className="absolute right-0 mt-2 w-64 max-h-[60vh] overflow-auto bg-white border border-[#D2E0E6] rounded-lg shadow-xl z-40 p-2">
          <div className="flex items-center justify-between px-2 py-1.5 mb-1 border-b border-[#E6EEF1]">
            <span className="text-[10px] uppercase tracking-[0.15em] text-[#7C949C]">Show columns</span>
            <div className="flex gap-2">
              <button data-testid="columns-all" onClick={() => setAll(true)} className="text-[11px] text-[#0284C7] hover:underline">All</button>
              <button data-testid="columns-none" onClick={() => setAll(false)} className="text-[11px] text-[#7C949C] hover:underline">None</button>
            </div>
          </div>
          {STOCK_COLUMNS.map((c) => {
            const on = visibleColumns.includes(c.key);
            return (
              <button key={c.key} data-testid={`col-toggle-${c.key}`} onClick={() => toggle(c.key)}
                className="w-full flex items-center gap-2.5 px-2 py-1.5 rounded hover:bg-[#E9F1F4] text-left transition-colors">
                <span className={`inline-flex items-center justify-center w-4 h-4 rounded border ${on ? "bg-[#0284C7] border-[#0284C7]" : "bg-white border-[#C3D2D8]"}`}>
                  {on && <Check className="w-3 h-3 text-white" />}
                </span>
                <span className="text-sm text-[#0B2830]">{c.label}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
